<template>
  <div class="" :class="ClaseContenido()">
    <div class="TituloMapa">
      {{TituloMapa}}
    </div>
    <gmap-map
      ref="gmap"
      :center="center"
      :style="EstiloGmap()"

      :map-type-id="mapTypeId"
      :options="{
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUI: false
      }"
    >
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        @click="toggleInfoWindow(m)"
      ></gmap-marker>

      <gmap-info-window
        :options="infoOptions"
        :position="infoWindowPos"
        :opened="infoWinOpen"
        @closeclick="infoWinOpen=false"
      >
        <div v-html="infoContent"></div>

        <GraficoLineal v-if="DataEjeX.length > 0"
          :id-herramienta="idHerramienta"
          :type="this.TipoGrafico"
          TituloEjeY="ml"
          :DataEjeX="DataEjeX"
          :DataEjeY="DataEjeY"
        />
      </gmap-info-window>
    </gmap-map>
  </div>
</template>

<script>
//TODO: Refactorizar
const MisClases = require("../../Auxiliares/Clases.js");
import axios from "axios";
import VueApexCharts from "vue-apexcharts";
import GraficoLineal from '../../components/Utilidades/GraficoLineal';

export default {
  name: "GoogleMap",
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      idHerramienta: 4,
      //a default center for the map
      TituloMapa: "",
      _Tipo: 1, // 1 pluviometros, 2 freatimetros
      map: null,
      mapTypeId: "hybrid",
      infoContent: "",
      center: { lat: -31.090, lng: -61.902 },
      // zoom: 18,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      //optional: offset infowindow so it visually sits nicely on top of our marker
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      markers: [],
      //Grafico
      Registros: [],
      DataEjeX: [],
      DataEjeY: [],
      TipoGrafico: "bar"
    };
  },
  mounted() {
    if (this.$route.query.t == 2) this.idHerramienta = 5;
    this._UserOk = MisClases.RecuperarJsonDeStorage(this.$parent.Datos.KeyUser());
    this.ObtenerDatos();
    this.TituloMapa = "Pluviómetros";
    if (this.$route.query.t == 2){
      this.TituloMapa = "Freatímetros";
      this.TipoGrafico = "line";
    }
  },
  methods: {
    async ObtenerDatos() {
      var _This = this;
      var _UrlPost = this.urlPosts + "/AgroIdeas/MapaPluviometros";
      if (this.$route.query.t == 2){
        _UrlPost = this.urlPosts + "/AgroIdeas/MapaFreatimetros";
      }
      var _InfoMapa = null;
      try {
        var _IdUsuario = 0;
        if (this._UserOk) {
          _IdUsuario = this._UserOk._ID;
        }
        await axios
          .post(_UrlPost, { IdUsuario: _IdUsuario })
          .then(function (response) {
            _InfoMapa = response.data;
            MisClases.GuardarJsonEnStorage(_This.ObtenerKey(), _InfoMapa);
          })
          .catch(function (e) {
            console.log(e);
          })
          .then(function () {});

          if (_InfoMapa == null){
            _InfoMapa = MisClases.RecuperarJsonDeStorage(this.ObtenerKey());
          }

          if (_InfoMapa != null){
            this.AuxiliarSetearData(_InfoMapa);
          }
      } catch (error) {
        console.log(error);
      }

      if(this.$route.query.idpres){
        let _Marcador = this.markers.find(e => e.id == this.$route.query.idpres);
        let _This = this;
        if (_Marcador){
          setTimeout(() => {
            _This.toggleInfoWindow(_Marcador);
          }, 300);
        }
      }
      //this.toggleInfoWindow();
      //this.this.$route.query.t
    },
    ObtenerKey() {
      var _Retorno = "";
      if(this.$parent.Datos._User){
        _Retorno = "InfoMapa-" + this.$parent.Datos._User._ID + "-" + this.$route.query.t;
      }
      return _Retorno;
    },
    AuxiliarSetearData(_InfoMapa) {
      let Marcadores = [];
      this.Registros = [];
      _InfoMapa.forEach((obj) => {
        this.Registros[obj._Id] = obj._Registros;
        let _Geo = new MisClases.GeoLocation();
        _Geo.lat = parseFloat(obj._Geo._Lat);
        _Geo.lng = parseFloat(obj._Geo._Lng);

        let _Marcador = new MisClases.Marcador();
        _Marcador.id= obj._Id
        _Marcador.name = obj._NombreProductor;
        _Marcador.localidad = obj._Localidad;
        _Marcador.description = obj._Establecimiento;
        _Marcador.position = _Geo;
        Marcadores.push(_Marcador);
      });

      this.markers = Marcadores;

      this.CargarMarcadores();
    },
    CargarMarcadores() {
      try {
        this.$refs.gmap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds();
          for (let m of this.markers) {
            bounds.extend(m.position);
          }
          map.fitBounds(bounds);
          setTimeout(() => {
            map.setZoom(9);
            //console.log(map);
            //map.setCenter(-31.090, -61.902, 12);//lat: -31.090, lng: -61.902
          }, 10);
        });
      } catch (error) {
        console.log(error);
      }
    },
    ActualizarGrafico(registros) {
      var DataEjeX = [];
      var DataEjeY = [];

      if(registros){
        registros.forEach((obj) => {
          DataEjeX.push(obj._FechaAlta);
          DataEjeY.push(obj._Valor);
        });
      }

      if (this.idHerramienta == 4){
        var _Aux = DataEjeX.length;
        for (let index = _Aux; index < 7; index++) {
          DataEjeX.push("-");
        }
        _Aux = DataEjeY.length;
        for (let index = _Aux; index < 7; index++) {
          DataEjeY.push(0);
        }
      }

      DataEjeX.reverse();
      DataEjeY.reverse();

      DataEjeX = DataEjeX.slice(0, 7);
      DataEjeY = DataEjeY.slice(0, 7);


      this.DataEjeY = DataEjeY;
      this.DataEjeX = DataEjeX;

    },
    toggleInfoWindow(marker) {
      this.infoWindowPos = marker.position;
      this.infoContent = this.getInfoWindowContent(marker);

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == marker.id) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = marker.id;
        // console.log(marker);
        // console.log(idx);
        // console.log(this.Registros[marker.id]);
        if (this.Registros[marker.id].length > 0) {
          this.ActualizarGrafico(this.Registros[marker.id]);
        }
        else{
          this.ActualizarGrafico([]);
        }
      }
    },
    ClaseContenido(){
      var _Retorno = "w100 Contenido";
      if(this.$parent.Datos._User == null){
        _Retorno += " ContenidoAjustado";
      }
      return _Retorno;
    },
    EstiloGmap(){
      var _Retorno = "width:100%;  height: calc(100vh - 100px);";
      if(this.$parent.Datos._User == null){
        _Retorno = "width:100%;  height: 100vh;";
      }
      return _Retorno;

    },
    getInfoWindowContent: function (marker) {
      return `<div class="card">
                <div class="card-content">
                  <div class="media">
                    <div class="media-content">
                      ${marker.id} - ${marker.name}, ${marker.localidad}
                    </div>
                  </div>
                  <div class="content">
                    ${marker.description}
                  </div>
                </div>
              </div>`;
    },
  },
  components: {
    GraficoLineal
  },
};
</script>

<style lang="scss">
.ContenidoAjustado{
  margin: 0px 0px;
}
.TituloMapa{
    text-align: left;
    padding: 5px 10px;
    display: block;
    background-color: rgba(0,0,0,0.9);
    color: #ccc;
    position: fixed;
    top: 50px;
    left: 0;
    z-index: 1;
    border-radius: 0 0 10px 0;
    box-shadow: 0 0 10px #000;
}
.card-content{
  line-height:20px;
}
.gm-style-iw-c, .gm-style-iw-d {
  width: 95%;
  box-sizing: border-box;
  max-width: 500px !important;
  overflow: hidden !important;
}
@media (max-width: 360px) {
  .gm-style-iw-c {
    width: 350px;
  }
}

</style>
